import { postReq } from 'services/axios';
export var processIdCard = function processIdCard(formData) {
  return postReq("".concat(apiUrl, "/ocr/id-card"), formData);
};